import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { Box, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useLogin } from "../../contexts/LoginContext";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import Plans from "../components/Plans";


// Padrão visual compartilhado com as seções da home
const eyebrowSx = (dark) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    px: 1.75,
    py: 0.75,
    borderRadius: "999px",
    backgroundColor: dark ? "rgba(255, 200, 69, 0.12)" : "rgba(255, 200, 69, 0.25)",
    border: dark ? "1px solid rgba(255, 200, 69, 0.4)" : "none",
    color: dark ? "#ffc845" : "#0b243d",
    fontSize: "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
});

const primaryButtonSx = {
    px: 4,
    py: 1.75,
    fontSize: "1rem",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#ffc845",
    color: "#0b243d",
    borderRadius: "10px",
    boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
    transition: "all 0.2s ease",
    '&:hover': {
        backgroundColor: "#e9b53d",
        transform: "translateY(-2px)",
        boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
    },
};

const Planos = () => {
    const navigate = useNavigate();
    const { fetchLogin } = useLogin();
    const [isMobile, setIsMobile] = useState(false);
    const [periodicity, setPeriodicity] = useState("mensal");

    const token = localStorage.getItem("token");
    const [hasPlan, setHasPlan] = useState(false);

    const planosRef = useRef(null);

    const scrollToPlans = () => {
        if (planosRef.current) {
            planosRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };



    useEffect(() => {
        const checkHasPlan = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/hasPlan`, {
                headers: {
                    Authorization: `${token}`
                }
            });
            if (response.data.status === 200) {
                setHasPlan(true)
            } else {
                setHasPlan(false)
            }
        }
        checkHasPlan()
    }, [token])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const [objPlanos, setObjPlanos] = useState([]);

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarPlanos`);

            setObjPlanos(response.data.planos);
        }
        getPlanos();
    }, [])

    const plans = [
        {
            id: objPlanos[0]?.idPlano,
            title: objPlanos[0]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 20.000/mês;" },
                { label: "Até 3 NFs/mês;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[0]?.descricao,
            priceOld: objPlanos[0]?.valorAntigoMensal ? Number(objPlanos[0]?.valorAntigoMensal) : "",
            discount: objPlanos[0]?.descontoMensal ? Number(objPlanos[0]?.descontoMensal) : "",
            priceNew: Number(objPlanos[0]?.valorNovoMensal),
            priceOldYear: objPlanos[0]?.valorAntigoAnual ? Number(objPlanos[0]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[0]?.valorNovoAnual ? Number(objPlanos[0]?.valorNovoAnual) : "",
            discountYear: objPlanos[0]?.descontoAnual ? Number(objPlanos[0]?.descontoAnual) : "",
            img: "/assets/essencial.jpg",
        },
        {
            id: objPlanos[1]?.idPlano,
            title: objPlanos[1]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 40.000/mês;" },
                { label: "Até 10 NFs/mês;" },
                { label: "Folha de até 2 colaboradores;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "IRPF sócios (sob demanda, até 3);" },
                { label: "Atendimento online bimestral;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[1]?.descricao,
            priceOld: objPlanos[1]?.valorAntigoMensal ? Number(objPlanos[1]?.valorAntigoMensal) : "",
            discount: objPlanos[1]?.descontoMensal ? Number(objPlanos[1]?.descontoMensal) : "",
            priceNew: Number(objPlanos[1]?.valorNovoMensal),
            priceOldYear: objPlanos[1]?.valorAntigoAnual ? Number(objPlanos[1]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[1]?.valorNovoAnual ? Number(objPlanos[1]?.valorNovoAnual) : "",
            discountYear: objPlanos[1]?.descontoAnual ? Number(objPlanos[1]?.descontoAnual) : "",
            img: "/assets/profissional.jpg",
        },
        {
            id: objPlanos[2]?.idPlano,
            title: objPlanos[2]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 150.000/mês;" },
                { label: "Até 150 NFs/mês;" },
                { label: "Folha de até 5 colaboradores;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: " IRPF sócios (sob demanda, até 3);" },
                { label: "Atendimento online mensal;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[2]?.descricao,
            priceOld: objPlanos[2]?.valorAntigoMensal ? Number(objPlanos[2]?.valorAntigoMensal) : "",
            discount: objPlanos[2]?.descontoMensal ? Number(objPlanos[2]?.descontoMensal) : "",
            priceNew: Number(objPlanos[2]?.valorNovoMensal),
            priceOldYear: objPlanos[2]?.valorAntigoAnual ? Number(objPlanos[2]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[2]?.valorNovoAnual ? Number(objPlanos[2]?.valorNovoAnual) : "",
            discountYear: objPlanos[2]?.descontoAnual ? Number(objPlanos[2]?.descontoAnual) : "",
            img: "/assets/expert.jpg",
        },
        {
            id: objPlanos[3]?.idPlano,
            title: objPlanos[3]?.nome,
            height: 700,
            chips: [
                { label: "Simples Nacional e outros regimes;" },
                { label: "Emissão de NF sob medida;" },
                { label: "Folha de pagamento personalizada;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "IRPF até 2 sócios inclusos;" },
                { label: "Atendimento online ilimitado sob demanda;" },
                { label: "Condições personalizadas de pagamento;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[3]?.descricao,
            priceOld: objPlanos[3]?.valorAntigoMensal ? Number(objPlanos[3]?.valorAntigoMensal) : "",
            discount: objPlanos[3]?.descontoMensal ? Number(objPlanos[3]?.descontoMensal) : "",
            priceNew: Number(objPlanos[3]?.valorNovoMensal),
            priceOldYear: objPlanos[3]?.valorAntigoAnual ? Number(objPlanos[3]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[3]?.valorNovoAnual ? Number(objPlanos[3]?.valorNovoAnual) : "",
            discountYear: objPlanos[3]?.descontoAnual ? Number(objPlanos[3]?.descontoAnual) : "",
            img: "/assets/plus.jpg",
        }
    ];


    return (
        <>
            <Header active="planos" />
            {/* Abertura */}
            <Box
                component="section"
                sx={{
                    position: "relative",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #0b243d 0%, #12365a 100%)",
                    color: "#fff",
                    pt: { xs: "120px", md: "140px" },
                    pb: { xs: 8, md: 10 },
                    overflow: "hidden",
                }}
            >
                {/* Detalhe decorativo */}
                <Box
                    sx={{
                        position: "absolute",
                        bottom: { xs: -100, md: -160 },
                        left: { xs: -100, md: -160 },
                        width: { xs: 240, md: 380 },
                        height: { xs: 240, md: 380 },
                        borderRadius: "50%",
                        border: { xs: "36px solid #ffc845", md: "56px solid #ffc845" },
                        opacity: 0.1,
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        width: "90%",
                        maxWidth: "1280px",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                        alignItems: "center",
                        gap: { xs: 6, md: 8 },
                    }}
                >
                    {/* Texto */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <Box sx={{ ...eyebrowSx(true), mb: 2.5 }}>
                            <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                            Planos Clarea
                        </Box>
                        <h1 style={{ margin: "0 0 20px", fontSize: "clamp(2rem, 4.4vw, 3.2rem)", fontWeight: 800, lineHeight: 1.15, letterSpacing: "-0.5px" }}>
                            Planos pensados para quem{" "}
                            <span style={{ color: "#ffc845" }}>cuida de vidas</span>
                        </h1>
                        <Box component="p" sx={{ m: 0, fontSize: { xs: "1rem", md: "1.1rem" }, lineHeight: 1.7, color: "rgba(255, 255, 255, 0.82)" }}>
                            Nossos planos contábeis foram desenvolvidos especialmente para médicos, dentistas, psicólogos, fisioterapeutas e demais profissionais da saúde. Oferecemos soluções práticas e seguras que garantem o cumprimento das obrigações fiscais com total transparência, agilidade e tranquilidade. Cuidamos da parte contábil para que você possa focar no que realmente importa: <b style={{ color: "#fff" }}>cuidar de pessoas.</b>
                        </Box>

                        <Box sx={{ mt: 4, display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1.5 }}>
                            <Button variant="contained" onClick={scrollToPlans} sx={primaryButtonSx}>
                                Comparar planos
                            </Button>
                            <Button
                                variant="outlined"
                                startIcon={<WhatsAppIcon />}
                                onClick={() => window.open(gerarLinkWhatsApp("Olá! Estou vendo os planos da Clarea e gostaria de ajuda para escolher o ideal."))}
                                sx={{
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#fff",
                                    borderColor: "rgba(255, 255, 255, 0.4)",
                                    borderRadius: "10px",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        borderColor: "#fff",
                                        backgroundColor: "rgba(255, 255, 255, 0.08)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                Me ajude a escolher
                            </Button>
                        </Box>

                        <Box
                            sx={{
                                mt: 5,
                                pt: 3,
                                borderTop: "1px solid rgba(255, 255, 255, 0.12)",
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                flexWrap: "wrap",
                                gap: { xs: 1.25, sm: 3 },
                            }}
                        >
                            {["Sem multa e sem fidelidade", "Suporte da nossa equipe", "Acesso imediato à plataforma"].map((item) => (
                                <Box key={item} sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: "0.9rem", color: "rgba(255, 255, 255, 0.85)" }}>
                                    <CheckIcon sx={{ fontSize: 18, color: "#ffc845" }} />
                                    {item}
                                </Box>
                            ))}
                        </Box>
                    </motion.div>

                    {/* Imagem */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <Box sx={{ position: "relative", maxWidth: { xs: "520px", md: "none" }, mx: "auto" }}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: { xs: -24, md: -36 },
                                    right: { xs: -24, md: -36 },
                                    width: { xs: 110, md: 160 },
                                    height: { xs: 110, md: 160 },
                                    borderRadius: "50%",
                                    border: { xs: "20px solid #ffc845", md: "28px solid #ffc845" },
                                    opacity: 0.35,
                                }}
                            />
                            <Box
                                component="img"
                                src="/assets/planosPage.jpg"
                                alt="Profissional da saúde"
                                sx={{
                                    position: "relative",
                                    display: "block",
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "24px",
                                    objectFit: "cover",
                                    boxShadow: "0 24px 60px rgba(0, 0, 0, 0.4)",
                                }}
                            />
                        </Box>
                    </motion.div>
                </Box>
            </Box>

            {/* <WhatWeDo scrollToPlans={scrollToPlans} /> */}
            {/* <Plans /> */}

            {/* Detalhes de cada plano */}
            {plans.filter((plan) => plan.title).map((plan, index) => {
                const invertido = index % 2 !== 0;
                const isSobConsulta = plan.id === 4;
                // Menor preço mensal entre o plano mensal e o anual
                const menorPreco = Math.min(...[plan.priceNew, plan.priceNewYear].filter((valor) => Number(valor) > 0));

                return (
                    <Box
                        key={index}
                        component="section"
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: index % 2 === 0 ? "#fff" : "#f9f2e4",
                            py: { xs: 7, md: 10 },
                            overflow: "hidden",
                        }}
                    >
                        <Box
                            sx={{
                                width: "90%",
                                maxWidth: "1280px",
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                                alignItems: "center",
                                gap: { xs: 5, md: 8 },
                            }}
                        >
                            {/* Texto */}
                            <motion.div
                                initial={{ opacity: 0, x: invertido ? 50 : -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.7 }}
                                viewport={{ once: true, amount: 0.2 }}
                                style={{ order: isMobile ? 2 : invertido ? 2 : 1 }}
                            >
                                <Box sx={{ ...eyebrowSx(false), mb: 2 }}>
                                    <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                                    Plano {String(index + 1).padStart(2, "0")}
                                </Box>
                                <h2 style={{ margin: "0 0 12px", fontSize: "clamp(1.8rem, 3.2vw, 2.4rem)", fontWeight: 800, lineHeight: 1.2, letterSpacing: "-0.5px", color: "#0b243d" }}>
                                    {plan.title}
                                </h2>
                                <Box component="p" sx={{ m: 0, fontSize: { xs: "1rem", md: "1.05rem" }, lineHeight: 1.7, color: "#4b5563" }}>
                                    {plan.description}
                                </Box>

                                {/* Benefícios */}
                                <Box
                                    component="ul"
                                    sx={{
                                        listStyle: "none",
                                        m: "24px 0 0",
                                        p: 0,
                                        display: "grid",
                                        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                        gap: 1.25,
                                    }}
                                >
                                    {plan.chips.map((advantage, i) => (
                                        <Box component="li" key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
                                            <Box
                                                sx={{
                                                    width: 22,
                                                    height: 22,
                                                    mt: "1px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#0b243d",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <CheckIcon sx={{ fontSize: 14, color: "#ffc845" }} />
                                            </Box>
                                            <Box sx={{ fontSize: "0.95rem", lineHeight: 1.5, color: "#374151" }}>
                                                {advantage.label.trim().replace(/[;.]$/, "")}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>

                                {plan.finalText && (
                                    <Box component="p" sx={{ m: "20px 0 0", fontWeight: 700, color: "#0b243d" }}>{plan.finalText}</Box>
                                )}

                                <Box sx={{ mt: 4, display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" }, gap: { xs: 1.5, sm: 3 } }}>
                                    {isSobConsulta ? (
                                        <Button
                                            variant="contained"
                                            startIcon={<WhatsAppIcon />}
                                            onClick={() => window.open(gerarLinkWhatsApp("Olá, tenho interesse no plano *Plus Personalizado* (Sob Consulta). Poderia me enviar mais informações?"))}
                                            sx={primaryButtonSx}
                                        >
                                            Quero contratar
                                        </Button>
                                    ) : (
                                        <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={scrollToPlans} sx={primaryButtonSx}>
                                            Quero contratar
                                        </Button>
                                    )}
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "center", sm: "flex-start" }, gap: 1, color: "#6b7280", fontSize: "0.9rem" }}>
                                        <CheckIcon sx={{ fontSize: 18, color: "#c8961e" }} />
                                        Sem multa e sem fidelidade
                                    </Box>
                                </Box>
                            </motion.div>

                            {/* Imagem */}
                            <motion.div
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.7, delay: 0.15 }}
                                viewport={{ once: true, amount: 0.2 }}
                                style={{ order: isMobile ? 1 : invertido ? 1 : 2 }}
                            >
                                <Box sx={{ position: "relative", maxWidth: { xs: "520px", md: "none" }, mx: "auto" }}>
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            [invertido ? "left" : "right"]: { xs: -12, md: -20 },
                                            bottom: { xs: -12, md: -20 },
                                            width: "60%",
                                            height: "60%",
                                            borderRadius: "24px",
                                            backgroundColor: "#0b243d",
                                        }}
                                    />
                                    <Box
                                        component="img"
                                        src={plan.img}
                                        alt={plan.title}
                                        sx={{
                                            position: "relative",
                                            display: "block",
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "24px",
                                            objectFit: "cover",
                                            boxShadow: "0 20px 50px rgba(11, 36, 61, 0.25)",
                                        }}
                                    />

                                    {/* Card de preço */}
                                    {!isSobConsulta && Number.isFinite(menorPreco) && (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                [invertido ? "right" : "left"]: { xs: 12, md: "-4%" },
                                                top: { xs: 12, md: "10%" },
                                                backgroundColor: "#fff",
                                                borderRadius: "14px",
                                                px: { xs: 1.75, md: 2.25 },
                                                py: { xs: 1.25, md: 1.5 },
                                                boxShadow: "0 12px 30px rgba(11, 36, 61, 0.2)",
                                            }}
                                        >
                                            <Box sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                                A partir de
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                                <Box sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" }, fontWeight: 800, color: "#0b243d" }}>
                                                    {menorPreco.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                                </Box>
                                                <Box sx={{ fontSize: "0.8rem", color: "#6b7280" }}>/mês</Box>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            </motion.div>
                        </Box>
                    </Box>
                );
            })}

            <div ref={planosRef} style={{ scrollMarginTop: "80px" }}>
                <Plans title="Compare os Planos" />
            </div>


            <Footer />
        </>
    );
};

export default Planos;
